import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const sidenavbarSlice = createSlice({
  name: "devsidenavbar",
  initialState: {
    sidenav: localStorage.getItem("sidenav") === "false",

  },
  reducers: {
    devIsSidenav: (state, action: PayloadAction<{ sidenav: boolean, side_nav_AppName?:any }>) => {
      const { sidenav,side_nav_AppName } = action.payload;
      state.sidenav = sidenav;

      setUserAuth(sidenav);
    },
    devIsSidenavdefault: (state) => {
      state.sidenav = false;
      removeUserAuth();
    },
  },
});

const setUserAuth = (sidenav: boolean) => {
  localStorage.setItem("sidenav", String(sidenav));

};

const removeUserAuth = () => {
  localStorage.removeItem("sidenav");

};

export const { devIsSidenav, devIsSidenavdefault } = sidenavbarSlice.actions;
export default sidenavbarSlice.reducer;

export interface IsidenavbarSlice {
  sidenav: boolean;

}
